import { type RefObject, useEffect, useState } from 'react';

export const showOverlayHook = (
    tbodyRef: RefObject<HTMLTableSectionElement>,
) => {
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);

    useEffect(() => {
        if (
            tbodyRef.current &&
            tbodyRef.current?.scrollHeight > tbodyRef.current.clientHeight
        ) {
            setIsOverlayVisible(true);
        }
    }, [tbodyRef]);

    return isOverlayVisible;
};
